import moment from "moment";
import "moment/locale/es";
import { dineroDisabledMask } from "../Components/Items";
import { HeaderEmpresaCard } from "../Components/PdfComponents/HeaderEmpresaCard";
import BIWO_LOGO_FOOTER from "../Components/PdfComponents/componentsv2.0/biwoLogoFooter";

moment.locale("es");

const footerBiwo = {
  stack: [
    { text: "Hecho por", fontSize: 7, color: "#999999", alignment: "center", margin: [0, 0, 0, 1] },
    { image: "logoBiwo", width: 50, alignment: "center" },
  ],
  margin: [0, 4, 0, 6],
};

const borderLayout = {
  hLineWidth: () => 1,
  vLineWidth: () => 1,
  hLineColor: () => "#adaaaa",
  vLineColor: () => "#adaaaa",
  hLineStyle: (i, node) => {
    if (i === 0 || i === node.table.body.length) return null;
    return { dash: { length: 2, space: 1 } };
  },
  vLineStyle: (i, node) => {
    if (i === 0 || i === node.table.widths.length) return null;
    return { dash: { length: 2 } };
  },
};

// pdfMake SOLO soporta PNG y JPEG en imágenes. webp/gif/etc. rompen la generación.
const esImagenPdfSoportada = (s) =>
  typeof s === "string" && /^data:image\/(png|jpe?g);base64,/i.test(s);

const BLANK_PNG =
  "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mNkYPhfDwAChwGA60e6kgAAAABJRU5ErkJggg==";


export const extraerFotosCarga = (d = {}) => {
  const defs = [
    [d.fotoOdometro, "Odómetro"],
    [d.fotoBomba, "Bomba de gasolina"],
    [d.fotoTanque, "Tanque"],
    [d.fotoExtra, "Extra"],
  ];
  const fotos = [];
  let omitidas = 0;
  defs.forEach(([arr, label]) => {
    const el = (arr || [])[0];
    if (!el || !el.base64) return;
    const ext = (el.extension || "").toLowerCase();
    if (!["png", "jpg", "jpeg"].includes(ext)) {
      omitidas += 1;
      return;
    }
    const mimetype = ext === "jpg" ? "jpeg" : ext;
    fotos.push({ label, base64: `data:image/${mimetype};base64,${el.base64}` });
  });
  return { fotos, omitidas };
};

const reporteCargaCombustiblePdf = (values) => {
  const { empresa, vehiculoNombre, carga, fotos } = values;

  const km = carga.kmRecorridos;
  const rendimiento = carga.rendimiento;

  const terceraColumna = {
    border: [false, false, false, false],
    table: {
      headerRows: 1,
      widths: ["100%"],
      body: [
        [{ text: "Registro de Carga", style: "subheader", alignment: "center" }],
        [{ text: vehiculoNombre || "", style: "textoChico", alignment: "center" }],
        [{ text: "Fecha de Impresión:", style: "subheader", alignment: "center" }],
        [{ text: moment().locale("es").format("ll"), style: "textoChico", alignment: "center" }],
      ],
    },
    layout: "noBorders",
  };

  const fotosValidas = (fotos || []).filter((f) => esImagenPdfSoportada(f.base64));
  const filasFotos = [];
  for (let i = 0; i < fotosValidas.length; i += 2) {
    const grupo = fotosValidas.slice(i, i + 2);
    // Encabezados de la pareja
    filasFotos.push(
      grupo
        .map((f) => ({ text: f.label, style: "tituloTabla", alignment: "center" }))
        .concat(grupo.length < 2 ? [{ text: "", border: [false, false, false, false] }] : [])
    );
    // Imágenes de la pareja
    filasFotos.push(
      grupo
        .map((f) => ({
          image: f.base64,
          fit: [230, 230],
          alignment: "center",
          margin: [4, 4, 4, 8],
        }))
        .concat(grupo.length < 2 ? [{ text: "", border: [false, false, false, false] }] : [])
    );
  }

  const dd = {
    content: [
      {
        style: "tableExample",
        table: {
          widths: ["18%", "52%", "30%"],
          body: [[...HeaderEmpresaCard(empresa || {}, false, false, terceraColumna)]],
        },
        layout: "noBorders",
      },

      { text: "Datos de la Carga", style: "subheader", margin: [0, 8, 0, 4] },
      {
        style: "tableExample",
        table: {
          widths: ["25%", "25%", "25%", "25%"],
          body: [
            [
              { text: "Fecha de Carga", style: "tituloTabla", alignment: "center" },
              { text: "Chofer", style: "tituloTabla", alignment: "center", colSpan: 3 },
              {},
              {},
            ],
            [
              { text: carga.fecha ? moment(carga.fecha).format("DD/MM/YYYY") : "—", style: "kpiValor", alignment: "center" },
              { text: carga.choferNombre || "—", style: "kpiValor", alignment: "center", colSpan: 3 },
              {},
              {},
            ],
            [
              { text: "KM Odómetro", style: "tituloTabla", alignment: "center" },
              { text: "Litros", style: "tituloTabla", alignment: "center" },
              { text: "Tipo", style: "tituloTabla", alignment: "center" },
              { text: "Precio / L", style: "tituloTabla", alignment: "center" },
            ],
            [
              { text: `${(carga.kmOdometro || 0).toLocaleString("es-MX")} km`, style: "kpiValor", alignment: "center" },
              { text: `${(carga.litros || 0).toFixed(3)} L`, style: "kpiValor", alignment: "center" },
              { text: (carga.tipoCombustible || "").toUpperCase(), style: "kpiValor", alignment: "center" },
              { text: dineroDisabledMask(carga.precioPorLitro), style: "kpiValor", alignment: "center" },
            ],
            [
              { text: "Total", style: "tituloTabla", alignment: "center" },
              { text: "KM Recorridos", style: "tituloTabla", alignment: "center" },
              { text: "Rendimiento", style: "tituloTabla", alignment: "center" },
              { text: "Factura", style: "tituloTabla", alignment: "center" },
            ],
            [
              { text: dineroDisabledMask(carga.total), style: "kpiValor", alignment: "center" },
              { text: km != null ? `${km.toFixed(2)} km` : "—", style: "kpiValor", alignment: "center" },
              { text: rendimiento != null ? `${rendimiento.toFixed(3)} km/L` : "—", style: "kpiValor", alignment: "center" },
              {
                text: carga.factura
                  ? carga.factura.codigoFactura ||
                    (carga.factura.numeroFactura != null ? String(carga.factura.numeroFactura) : "—")
                  : "—",
                style: "kpiValor",
                alignment: "center",
              },
            ],
          ],
        },
        layout: borderLayout,
      },

      ...(filasFotos.length > 0
        ? [
            { text: "Evidencia Fotográfica", style: "subheader", margin: [0, 12, 0, 4] },
            {
              style: "tableExample",
              table: { widths: ["50%", "50%"], body: filasFotos },
              layout: "noBorders",
            },
          ]
        : []),
    ],
    footer: footerBiwo,
    images: {
      logo: esImagenPdfSoportada(empresa?.logo?.base64Completa)
        ? empresa.logo.base64Completa
        : BLANK_PNG,
      logoBiwo: BIWO_LOGO_FOOTER,
    },
    styles: {
      tableHeader: { bold: true, fontSize: 12, color: "black", alignment: "center" },
      subheader: { fontSize: 9, bold: true },
      tableExample: { margin: [0, 5, 0, 5] },
      tituloTabla: { fontSize: 8, bold: true, fillColor: "#cccccc", alignment: "center" },
      textoChico: { fontSize: 8 },
      kpiValor: { fontSize: 11, bold: true },
    },
    pageSize: "LETTER",
    pageOrientation: "portrait",
    pageMargins: [30, 20, 30, 55],
  };

  return dd;
};

export default reporteCargaCombustiblePdf;
